import { theme } from '@noths/polaris-client-ribbons-base';
import { css } from 'styled-components';

const { responsiveText, spacing } = theme;

export const container = css`
  display: block;
  position: absolute;
  top: auto;
  left: 0;
  right: 0;
  background-color: var(--neutral-white-base);
  z-index: 3;
  margin-top: 1px;
  box-shadow: rgba(0, 0, 0, 0.18) 0 24px 32px;
`;

export const navContainer = css`
  max-width: 1156px;
  margin: 0 auto;
  padding: ${spacing.md}px;
  box-sizing: border-box;
  display: grid;
  grid-template-columns: 300px 1fr;
  grid-column-gap: 20px;

  a {
    text-decoration: none;
  }
`;

export const level2 = css`
  margin: 0;
  padding: 0;
  list-style: none;
  font-weight: bold;

  li {
    padding: 0;

    a,
    button {
      display: flex;
      justify-content: space-between;
      padding: ${spacing.sm}px;
      ${responsiveText.BODY.MD};
      font-weight: 600;
      text-align: left;
    }
  }

  button {
    border: none;
    background-color: transparent;
    width: 100%;
  }

  li[aria-current] {
    border-radius: ${spacing.xs}px;
    &:not([aria-current='true']):nth-child(odd) {
      background-color: rgba(208, 208, 208, 0.1);
    }

    a,
    button {
      color: var(--neutral-black-base);
    }
  }

  li[aria-current='true'] {
    background-color: var(--brand-purple-10);
  }

  li[aria-current='true'],
  li:last-child {
    a,
    button {
      color: var(--brand-purple-base);
    }
  }
`;

export const level3 = css`
  align-self: stretch;
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  flex-grow: 1;
  justify-content: start;
  align-items: flex-start;
  align-content: flex-start;
  max-height: 500px;

  li {
    padding: 0 0 ${spacing.xs}px;
    min-width: 200px;
    max-width: 50%;

    a {
      display: block;
      padding: ${spacing.xs}px;
      color: var(--neutral-black-base);
      ${responsiveText.BODY.MD};

      &:hover {
        color: var(--brand-purple-base);
        text-decoration: underline;
      }
    }
  }
`;
